// import React from 'react';
// import { Navigate, useLocation } from 'react-router-dom';

// const ProtectedRoute = ({ element, allowedUserTypes }) => {
//   const userType = parseInt(localStorage.getItem('name')); // Or from context/store
//   const location = useLocation();

//   if (allowedUserTypes.includes(userType)) {
//     return element;
//   } else {
//     return <Navigate to="/pagenotfound" state={{ from: location }} replace />;
//   }
// };

// export default ProtectedRoute;


// import React, { useEffect, useState } from 'react';
// import { Navigate, useLocation } from 'react-router-dom';
// import axios from 'axios';
// import Loader from '../components/loader';

// const ProtectedRoute = ({ element, allowedUserTypes }) => {
//     const [userType, setUserType] = useState(null);
//     const [userSource, setUserSource] = useState(null);
//     const [loading, setLoading] = useState(true);
//     const location = useLocation();

//     useEffect(() => {
//         const fetchUser = async () => {
//             try {
//                 const res = await axios.get('/we/we/userCheckApi/');
//                 console.log("Fetched user data:", res.data);

//                 const type = parseInt(res.data.User_Type);
//                 const user_source = res.data.source;
//                 setUserType(type);
//                 setUserSource(user_source);

//                 console.log("Parsed User_Type:", type);
//                 console.log("Parsed User_source:", user_source);
//             } catch (error) {
//                 console.error('Error fetching user:', error);
//                 setUserType(null);
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchUser();
//     }, []);

//     if (loading) {
//         return <Loader />;
//     }

//     if (allowedUserTypes.includes(userType)) {
//         return element;
//     } else {
//         return <Navigate to="/pagenotfound" state={{ from: location }} replace />;
//     }
// };

// export default ProtectedRoute;







// import React, { useEffect, useState } from 'react';
// import { Navigate, useLocation } from 'react-router-dom';
// import axios from 'axios';
// import Loader from '../components/loader';

// const ProtectedRoute = ({ element, allowedUserTypes, allowedUserSources }) => {
//     const [userType, setUserType] = useState(null);
//     const [userSource, setUserSource] = useState(null);
//     const [userPermissions, setUserPermissions] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const location = useLocation();

//     useEffect(() => {
//         const fetchUser = async () => {
//             try {
//                 const res = await axios.get('/we/we/userCheckApi/');
//                 console.log("Fetched user data:", res.data);

//                 const type = parseInt(res.data.User_Type);
//                 const source = res.data.source;
//                 const permissions = res.data.permissions;

//                 setUserType(type);
//                 setUserSource(source);
//                 setUserPermissions(permissions);

//                 console.log("Parsed User_Type:", type);
//                 console.log("Parsed User_Source:", source);
//                 console.log("Parsed permissions:", permissions);
//             } catch (error) {
//                 console.error('Error fetching user:', error);
//                 setUserType(null);
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchUser();
//     }, []);

//     if (loading) {
//         return <Loader />;
//     }

//     const isUserTypeAllowed = allowedUserTypes?.includes(userType);
//     const isUserSourceAllowed =
//         userType === 4 && allowedUserSources
//             ? allowedUserSources.includes(userSource)
//             : true;

//     if (isUserTypeAllowed && isUserSourceAllowed) {
//         return element;
//     } else {
//         return <Navigate to="/pagenotfound" state={{ from: location }} replace />;
//     }
// };

// export default ProtectedRoute;





import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import Loader from '../components/loader';

const ProtectedRoute = ({
  element,
  allowedUserTypes,
  allowedUserSources,
  requiredModuleKey,
}) => {
  const [userType, setUserType] = useState(null);
  const [userSource, setUserSource] = useState(null);
  const [userPermissions, setUserPermissions] = useState({});
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const res = await axios.get('/we/we/userCheckApi/');
        const type = parseInt(res.data.User_Type);
        const source = res.data.source;
        const permissions = res.data.permissions?.[0] || {};

        setUserType(type);
        setUserSource(source);
        setUserPermissions(permissions);

        console.log("User_Type:", type);
        console.log("User_Source:", source);
        console.log("Permissions:", permissions);
      } catch (error) {
        console.error('Error fetching user:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchUser();
  }, []);

  if (loading) return <Loader />;

  const isUserTypeAllowed = allowedUserTypes?.includes(userType);

  // ✅ Only check source if userType === 4
  const isUserSourceAllowed =
    userType === 4 && allowedUserSources
      ? allowedUserSources.includes(userSource)
      : true;

  // ✅ Only check module permission if userType === 4 and requiredModuleKey is provided
  const hasModulePermission =
    userType === 4 && requiredModuleKey
      ? requiredModuleKey in userPermissions
      : true;

  if (isUserTypeAllowed && isUserSourceAllowed && hasModulePermission) {
    return React.cloneElement(element, { userPermissions });
  } else {
    return <Navigate to="/pagenotfound" state={{ from: location }} replace />;
  }
};

export default ProtectedRoute;






